/* @flow */

export default class SendProcurationEmailRequest {
  companyId: string;
}
